import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { withStyles } from '@material-ui/core/styles'
import { Button } from '@material-ui/core'

import * as DeviceActionCreators from '../../../actions/device'

class ZWaveController extends React.Component {
  static propTypes = {
    device: PropTypes.object.isRequired,
    deviceActions: PropTypes.object.isRequired,
  }

  static mapDispatchToProps(dispatch) {
    return {
      deviceActions: bindActionCreators(DeviceActionCreators, dispatch),
    }
  }

  static styles = {}

  onInclude = () => {
    this.props.deviceActions.executeCommand(this.props.device.id, 'include')
  }

  onExclude = () => {
    this.props.deviceActions.executeCommand(this.props.device.id, 'exclude')
  }

  onCancel = () => {
    this.props.deviceActions.executeCommand(this.props.device.id, 'cancel')
  }

  render() {
    return (
      <>
        <Button onClick={this.onInclude}>Include</Button>
        <Button onClick={this.onExclude}>Exclude</Button>
        <Button onClick={this.onCancel}>Cancel</Button>
      </>
    )
  }
}

export default connect(
  ZWaveController.mapStateToProps,
  ZWaveController.mapDispatchToProps,
)(withStyles(ZWaveController.styles)(ZWaveController))
